
export default {
  name: 'LearnIcon',
  props: {
    stroke: {
      type: String,
      default: null,
    },
    fill: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: '18',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    strokeWidth: {
      type: Number,
      default: 1.67,
    },
  },
  emits: ['onClick'],
  computed: {
    fillAndStrokeClass() {
      let res = '';
      // In order to trigger css animations we need to set the default stroke and fill here
      res += 'stroke-' + (this.stroke ? this.stroke : 'neutral-7');
      res += ' fill-' + (this.fill ? this.fill : 'none');

      return res;
    },
  },
};
